<template>
  <div class="login-container">
    <el-form :model="loginForm" :rules="fieldRules" ref="loginForm" label-position="left" label-width="0px"
             class="login-ruleForm ">
    <span class="tool-bar">
      <!-- 主题切换 -->
      <theme-picker style="float:right;" class="theme-picker" :default="themeColor"
                    @onThemeChange="onThemeChange"></theme-picker>
    </span>
      <h2 class="title" style="padding-left:22px;">系统登录</h2>
      <el-form-item prop="account">
        <el-input type="text" v-model="loginForm.account" auto-complete="off" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-col :span="12">
          <el-form-item prop="captcha">
            <el-input type="test" v-model="loginForm.captcha" auto-complete="off" placeholder="验证码, 单击图片刷新"
                      style="width: 100%;">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="1">&nbsp;</el-col>
        <el-col :span="11">
          <el-form-item>
            <img style="width: 100%;" class="pointer" :src="loginForm.src" @click="refreshCaptcha">
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:48%;" @click.native.prevent="reset">重 置</el-button>
        <el-button type="primary" style="width:48%;" @click.native.prevent="login" :loading="loading">登 录</el-button>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
import {mapState} from 'vuex'
import Cookies from "js-cookie"
import ThemePicker from "@/components/ThemePicker"

export default {
  name: 'Login',
  components: {
    ThemePicker
  },
  data() {
    return {
      loading: false,
      loginForm: {
        account: '',
        password: '',
        captcha: '',
        src: ''
      },
      fieldRules: {
        account: [
          {required: true, message: '请输入账号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ]
      },
      checked: true
    }
  },
  methods: {
    login() {
      this.loading = true
      sessionStorage.removeItem("user")
      sessionStorage.removeItem("hospitalId")
      sessionStorage.removeItem("deptId")
      let userInfo = {
        account: this.loginForm.account,
        password: this.loginForm.password,
        captcha: this.loginForm.captcha
      }
      this.$api.login.login (userInfo).then ((res) => {
        if (res.msg != null) {
          this.$message ({
            message: res.msg,
            type: 'error'
          })
        } else {
          Cookies.set ('token', res.data.token) // 放置token到Cookie
          console.log("登录信息： ",res)
          sessionStorage.setItem ('user', userInfo.account) // 保存用户到本地会话
          if (res.data.hospitalId){
            sessionStorage.setItem ('hospitalId', res.data.hospitalId) // 保存用户到本地会话
            sessionStorage.setItem ('deptId', res.data.deptId) // 保存用户到本地会话
          }
          this.$store.commit ('menuRouteLoaded', false) // 要求重新加载导航菜单
          this.$router.push ('/')  // 登录成功，跳转到主页
        }
        this.loading = false
      }).catch ((res) => {
        this.loading = false
        this.deleteCookie("token")
        this.$message ({
          message: res.message,
          type: 'error'
        })
      });
    },
    // 清除Cookie
    deleteCookie(name){
         var myDate = new Date()
         myDate.setTime(-1000) // 设置过期时间
         document.cookie = name+"=''; expires="+myDate.toGMTString();
         sessionStorage.clear()
    },
    refreshCaptcha: function () {
      this.loginForm.src = this.global.baseUrl + "/berry-admin/captcha.jpg?t=" + new Date ().getTime ();
    },
    reset() {
      this.$refs.loginForm.resetFields ()
    },
    // 切换主题
    onThemeChange: function (themeColor) {
      this.$store.commit ('setThemeColor', themeColor)
    }
  },
  mounted() {
    this.refreshCaptcha ()
  },
  computed: {
    ...mapState ({
      themeColor: state => state.app.themeColor
    })
  }
}
</script>

<style lang="scss" scoped>
.login-container {

  //background-color: aquamarine;
  .login-ruleForm {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 100px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;

    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #505458;
    }

    .remember {
      margin: 0px 0px 35px 0px;
    }
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue